export default __webpack_public_path__ + "dde159c3ff608b1da2c7d848869802ee.png";